import { logger } from '@/common/log';
import { afterPv } from '@/common/utils/afterPv';

export const logClickBuyNow = ({ item_id, skip_to = null, coupon_id = '', is_with_coupon = 0, item = null, button_type }) => {
    // skip_to:跳转类型，跳转至，0-商详，1-规格半屏，2-提单页
    // item_id:商品item_id
    // coupon_id: 券批次ID
    // is_with_coupon: 是否领取优惠券，0-否，1-是
    logger.sendClick({
        action: 'BUY_BUTTON',
        params: {
            item_id,
            skip_to,
            coupon_id,
            is_with_coupon,
            item,
            button_type,
        },
    });
};

export const onFlashVisible = ({ item_id }) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'SECKILL_TSG',
            params: {
                item_id,
            },
        });
    });
};

export const onUgcVisible = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'UGC_TEXT',
        });
    });
};

export const onKwaiGlodVisible = () => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'KWAI_GOALS_TAG',
        });
    });
};

export const logShowAddOnBar = (ifCheckOut) => {
    afterPv.then(() => {
        logger.sendShow({
            action: 'ADD_AND_OFF_BAR',
            params: {
                bar_version: Number(ifCheckOut), // 浮层条版本；0-引导凑单；1-结算版本
            },
        });
    });
};

export const logClickAddOnBar = (ifCheckOut) => {
    logger.sendClick({
        action: 'ADD_AND_OFF_BAR',
        params: {
            bar_version: Number(ifCheckOut), // 浮层条版本；0-引导凑单；1-结算版本
        },
    });
};

export const logClickAddOnCoupon = (batchId) => {
    logger.sendClick({
        action: 'BOUGHT_TOGETHER_GUIDE_BAR',
        params: {
            batch_id: batchId,
        },
    });
};

export const logShowAddOnCoupon = (batchId) => {
    logger.sendShow({
        action: 'BOUGHT_TOGETHER_GUIDE_BAR',
        params: {
            batch_id: batchId,
        },
    });
};
